import { Action } from '@/components/sections/Card';
import { Product } from '@/services/api/contracts/catalog/types';

import { usePOIsProductSelected, usePoSelectProduct } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FunctionComponent } from 'react';
import { FiX } from 'react-icons/fi';
import { twMerge } from 'tailwind-merge';

interface ToggleProductToOrderActionProps {
  product: Product;
}

const ToggleProductToOrderAction: FunctionComponent<ToggleProductToOrderActionProps> = ({ product }) => {
  const isProductSelected = usePOIsProductSelected(product);
  const toggleSelected = usePoSelectProduct(product);

  const onToggleSelected = () => {
    toggleSelected();
  };

  return (
    <Action onClick={onToggleSelected} className="flex w-full items-center justify-center gap-1 p-2 text-sm">
      <div className={twMerge('font-medium flex items-center gap-1', isProductSelected ? 'text-red-500' : '')}>
        {isProductSelected && <FiX />}
        <span>{isProductSelected ? 'Remove from order' : 'Add to order'}</span>
      </div>
    </Action>
  );
};

export default ToggleProductToOrderAction;
